<ng-select [class]="cssClass" [items]="people$ | async" bindLabel="key" [placeholder]="placeholder" [multiple]="allowMultiple" [ngClass]="{ 'is-formly-full': field != null && field.type && field.type != ''  }"
    [hideSelected]="true" [readonly]="readonly" [addTag]="allowAdding" [appendTo]="appendTo" [dropdownPosition]="dropdownPosition"
    [loading]="peopleLoading" [typeahead]="peopleInput$" (focus)="peopleInput$.next('')" [(ngModel)]="selectedContact"
    (change)="onTagSelectChange($event)" (clear)="onTagSelectRemove($event)">
    <ng-template ng-loadingspinner-tmp>
        <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </ng-template>
</ng-select>
